import { MetaMask } from '@web3-react/metamask'
import { WalletConnect } from '@web3-react/walletconnect'
import { WalletLink } from '@web3-react/walletlink'
import { ethers } from 'ethers'
import { connectors } from './connectors'

const providers = [
  { name: 'MetaMask', instance: MetaMask, icon: 'wallet/metamask.svg' },
  {
    name: 'WalletConnect',
    instance: WalletConnect,
    icon: 'wallet/walletconnect.svg'
  },
  {
    name: 'Coinbase Wallet',
    instance: WalletLink,
    icon: 'wallet/coinbasewallet.svg'
  }
]

export const getWalletProvider = connector => {
  return providers.find(provider => connector instanceof provider.instance)
}

export const walletConnectors = connectors

export const walletSigature = (provider, account, msg) => {
  const binMsg = ethers.utils.hexlify(ethers.utils.toUtf8Bytes(msg))
  return provider.request({
    method: 'personal_sign',
    params: [binMsg, account]
  })
}

export const walletSwitchEthChain = provider => {
  provider.request({
    method: 'wallet_switchEthereumChain',
    params: [{ chainId: '0x1' }] // chainId must be in hexadecimal numbers
  })
}
